import { render, staticRenderFns } from "./setting-insurance-type.vue?vue&type=template&id=19e7752a&"
import script from "./setting-insurance-type.vue?vue&type=script&lang=js&"
export * from "./setting-insurance-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports